import { ISelfHelpContext } from '@iris/react-webchat';

export class IRISBotSettings
{
    static readonly APP_NAME= "mcapsv2";
    static readonly PLATFORM_NAME= "azureapps";
    static readonly CREATE_SUPPORT_TICKET="create support ticket";
    static readonly WORKSTREAM="General Support Ticket";
    static readonly CHATBOT_AVATAR_ICON_URL= "https://iris-fd-cpc8d6c9buafasc2.b01.azurefd.net/iris-ux/assets/images/iris-copilot-icon.svg";
};

function resolveAreaOfInterest(userRoleName: any) {
  return userRoleName ? userRoleName : "Other";
}

function resolveSegment(userSegmentName: any, finalTileObject: any, segment: any) {
  if (userSegmentName) return userSegmentName;
  if (finalTileObject && finalTileObject["Segment"]) return finalTileObject["Segment"];
  return segment;
}

function resolveSubsegment(userSubSegmentName: any, finalTileObject: any, subsegment: any) {
  if (userSubSegmentName) return userSubSegmentName;
  if (finalTileObject && finalTileObject["SubSegment"]) return finalTileObject["SubSegment"];
  return subsegment;
}

function resolveTileName(tileName: any) {
  return tileName === null ? "" : tileName;
}

function resolveServiceGroup(finalTileObject: any) {
  return finalTileObject && finalTileObject["sendServiceGroup"]
    ? finalTileObject["defaultServiceGroup"]
    : "";
}

function getActivityContext(currentUserData, finalTileObject, segment, subsegment, workstream, searchTerm, tileName, formDataToIris, isSupportTicket) {
  const baseContext = {
    "area": currentUserData.userAreaName,
    "areaOfInterest": resolveAreaOfInterest(currentUserData.userRoleName),
    "segment": resolveSegment(currentUserData.userSegmentName, finalTileObject, segment),
    "subsegment": resolveSubsegment(currentUserData.userSubSegmentName, finalTileObject, subsegment),
  };

  if (isSupportTicket) {
    const context: any = {
      ...baseContext,
      "Name": workstream,
      "ShortDescription": searchTerm,
    };
    if (tileName !== "" && tileName !== null) {
      context["tileName"] = resolveTileName(tileName);
    }
    return context;
  }

  return {
    ...baseContext,
    "formFieldValues": formDataToIris,
    "tileName": resolveTileName(tileName),
    "serviceGroup": resolveServiceGroup(finalTileObject),
  };
}

export const getIrisSelfHelp = (
  irisContext: any,
  currentUserData: any,
  workstream?: string,
  searchTerm?: string,
  formDataToIris?: any,
  tileName?: any,
  finalTileObject?: any,
  segment?: any,
  subsegment?: any
): ISelfHelpContext => {

  const isSupportTicket = irisContext === IRISBotSettings.CREATE_SUPPORT_TICKET;

  if (isSupportTicket) {
    if (tileName !== "" && tileName !== null) {
      return {
        selfHelpEventName: "proactivecopilot",
        messages: [irisContext],
        activityContext: getActivityContext(currentUserData, finalTileObject, segment, subsegment, workstream, searchTerm, tileName, formDataToIris, true)
      };
    } else {
      return {
        selfHelpEventName: "proactivecopilot",
        messages: [irisContext],
        activityContext: getActivityContext(currentUserData, finalTileObject, segment, subsegment, workstream, searchTerm, tileName, formDataToIris, true)
      };
    }
  }

  return {
    selfHelpEventName: "proactivecopilot",
    messages: finalTileObject["sendServiceGroup"] ? [finalTileObject["IrisUtterance"]] : [irisContext],
    activityContext: getActivityContext(currentUserData, finalTileObject, segment, subsegment, workstream, searchTerm, tileName, formDataToIris, false)
  };
}




